import { createRouter, createWebHistory } from "vue-router";
import WelcomePage from "@/pages/WelcomePage.vue";
import CanvasPage from "@/pages/CanvasPage.vue";
import AdminDashboardPage from "@/pages/AdminDashboardPage.vue";
import AdminLoginPage from "@/pages/AdminLoginPage.vue";

const routes = [
  {
    path: "/",
    name: "welcome",
    component: WelcomePage,
  },
  {
    path: "/canvas",
    name: "canvas",
    component: CanvasPage,
  },
  {
    path: "/login",
    name: "Login",
    component: AdminLoginPage
  },
  {
    path: "/admin",
    name: "Admin",
    redirect: "/admin/dashboard",
    meta: { requiresAuth: true },

    children: [
      {
        name: "Dashboard",
        path: "dashboard",
        component: AdminDashboardPage,

      }
    ]
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Global navigation guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const hasBasicAuth = localStorage.getItem("demoBasicAuth") !== null;

  if (requiresAuth && !hasBasicAuth) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
